var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActionHistoryOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 21c-2.3 0-4.304-.763-6.012-2.288C4.279 17.187 3.3 15.283 3.05 13H5.1c.233 1.733 1.004 3.167 2.312 4.3C8.721 18.433 10.25 19 12 19c1.95 0 3.604-.68 4.962-2.038C18.321 15.604 19 13.95 19 12c0-1.95-.68-3.604-2.038-4.963C15.604 5.679 13.95 5 12 5a6.75 6.75 0 00-3.225.8A7.431 7.431 0 006.25 8H9v2H3V4h2v2.35a8.73 8.73 0 013.113-2.475A8.928 8.928 0 0112 3a8.71 8.71 0 013.513.712 9.168 9.168 0 012.85 1.925 9.167 9.167 0 011.925 2.85A8.715 8.715 0 0121 12c0 1.25-.237 2.42-.712 3.512a9.151 9.151 0 01-1.925 2.85 9.158 9.158 0 01-2.85 1.926A8.715 8.715 0 0112 21zm2.8-4.8L11 12.4V7h2v4.6l3.2 3.2-1.4 1.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionHistoryOutline);
export default __webpack_public_path__ + "1df2811a66728c15f968203b99ee8607.svg";
export { ForwardRef as ReactComponent };